import { Injectable } from '@angular/core';
import { BatchQuery } from '../../../models/batch-query';
import { Observable, of } from 'rxjs';
import { FilterAssist } from '../../../models/filter-assist';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';
import { FilterAssistQuery } from '../../../interfaces/filter-assist-query';
import { FilterService } from '../services/filter.service';

@Injectable({
    providedIn: 'root'
})
export class BatchFilterService extends FilterService<BatchQuery> implements FilterAssistQuery<BatchQuery> {

    private BATCH_FILTER = 'BATCH_FILTER';

    constructor() {
        super();
        this.registerFilters(this);
    }

    protected describe(terms: string): string {
        return $localize`Filter for "${terms}"`;
    }

    active(query: BatchQuery): Observable<FilterAssist[]> {
        if (query.name) {
            return of([ {
                id: this.BATCH_FILTER,
                description: this.describe(query.name),
                score: 50,
                parameter: query.name,
                category: FilterCategoryEnum.ANY
            } ]);
        }
        return of([]);
    }

    apply(id: string, parameter: any, query: BatchQuery): void {
        switch (id) {
            case this.BATCH_FILTER:
                query.name = parameter;
                break;
        }
    }

    ids(): string[] {
        return [ this.BATCH_FILTER ];
    }

    match(terms: string): Observable<FilterAssist[]> {
        if (terms.length < 2) {
            return of([]);
        }
        return of([ {
            id: this.BATCH_FILTER,
            parameter: terms,
            score: 50,
            description: this.describe(terms),
            category: FilterCategoryEnum.ANY
        } ]);
    }

    unapply(id: string, query: BatchQuery): void {
        switch (id) {
            case this.BATCH_FILTER:
                query.name = null;
                break;
        }
    }
}
